<template>
  <b-row>
    <b-col cols="" class="card-box" :class="expanded ? 'h-61vh' : 'h-64vh'">
      <div class="body-box">
        <RadarChart
          :labels="labels"
          :series="series"
          :yAxisRange="yAxisRange"
        />
        <b-row class="" align-h="center" align-v="center">
          <b-col>
            <b-table-simple bordered small responsive class="bg-white">
              <b-tbody>
                <b-tr>
                  <b-th rowspan="3">عملکرد</b-th>
                  <b-td>درجه قوت شایستگی</b-td>
                  <b-td class="text-center w-25">
                    {{ `%${overallData.desirability}` }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>ریسک</b-td>
                  <b-td class="text-center w-25">
                    {{ `%${overallData.risk}` }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>بازده انتظاری</b-td>
                  <b-td class="text-center w-25">
                    {{ `%${overallData.efficiency}` }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>
      </div>
      <slot name="user-box"></slot>
    </b-col>
    <b-col v-if="expanded" cols="7" class="expanded-box">
      <b-table-simple
        v-for="(item, index) in effectOfPositionOnSuccess"
        :key="`a-${index}`"
        bordered
        small
        responsive
        class="bg-white margin-bottom-2"
      >
        <b-tbody>
          <b-tr>
            <b-th class="w-50" rowspan="3">{{ item.caption }}</b-th>
            <b-td>درجه قوت شایستگی</b-td>
            <b-td class="text-center w-25">
              {{ `%${item.desirability}` }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>ریسک</b-td>
            <b-td class="text-center w-25">
              {{ `%${item.risk}` }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>بازده انتظاری</b-td>
            <b-td class="text-center w-25">
              {{ `%${item.efficiency}` }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-col>
  </b-row>
</template>

<script>
import { Radar as RadarChart } from "@/components/charts";
import { pathOr } from "ramda";

export default {
  components: { RadarChart },
  props: {
    item: {
      type: Object,
      default: null,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mockData: {
        competencies: [
          {
            label: "test1",
            value: 10,
          },
          {
            label: "test2",
            value: 30,
          },
          {
            label: "test3",
            value: 40,
          },
          {
            label: "test4",
            value: 20,
          },
        ],
      },
    };
  },
  computed: {
    labels() {
      const currentItem = pathOr([], ["competencies"], this.item);
      return currentItem.map((item) => item.name);
    },
    yAxisRange() {
      const output = [];
      const currentItem = pathOr([], ["competencies"], this.item);
      currentItem.map((item, index) => output.push(index));
      return output;
    },
    series() {
      const currentItem = pathOr([], ["competencies"], this.item);
      const data = currentItem.map((item) => item.score);
      const scoreAverages = currentItem.map((item) => item.score_avg);
      return [
        {
          type: "line",
          showInLegend: false,
          name: "شایستگی",
          data,
        },
        {
          type: "line",
          showInLegend: false,
          name: "میانگین",
          data: scoreAverages,
          color: '#FF0000'
        },
      ];
    },
    chartOptions() {
      const currentItem = pathOr([], ["competencies"], this.item);
      const categories = currentItem.map((item) => item.name);
      const data = currentItem.map((item) => item.score);
      return {
        chart: {
          polar: true,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  enabled: false,
                },
              },
            },
          ],
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
        },
        legend: {
          rtl: true,
        },
        xAxis: {
          tickInterval: 1,
          min: 0,
          max: 5,
          labels: {
            format: "",
          },
          categories,
        },
        yAxis: {
          min: 0,
          max: 5,
        },
        plotOptions: {
          series: {
            pointStart: 0,
            pointInterval: 1,
          },
        },
        series: [
          {
            type: "area",
            name: "شایستگی ها",
            data,
          },
        ],
      };
    },
    overallData() {
      return {
        caption: pathOr("", ["overall", "caption"], this.item),
        desirability: pathOr(0, ["overall", "desirability"], this.item),
        risk: pathOr(0, ["overall", "risk"], this.item),
        efficiency: pathOr(0, ["overall", "efficiency"], this.item),
      };
    },
    effectOfPositionOnSuccess() {
      const items = pathOr([], ["effect_of_position_on_success"], this.item);
      return items.map((item) => {
        return {
          caption: pathOr("", ["caption"], item),
          desirability: pathOr(0, ["desirability"], item),
          risk: pathOr(0, ["risk"], item),
          efficiency: pathOr(0, ["efficiency"], item),
        };
      });
    },
  },
  methods: { pathOr },
};
</script>

<style lang="scss" scoped>
.card-box {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.h-64vh {
  height: 64vh;
}
.h-61vh {
  height: 61vh;
}
ul {
  list-style: none;
  padding-right: 16px;
  margin: 0;
}
.expanded-box {
  height: 60vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    background-color: #eee;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 20px;
  }
}
</style>
